import React, { useState, useEffect } from "react";
import Table from "view/component/Table";
import apiService from "apiService";
import { InlineLoading } from "view/component/Loading";

const toBase64 = async (file) => {
  if (await file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
};

const UploadFile = ({ data, idPendaftaran }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = async (e, data) => {
    setIsLoading(true);
    const fileBase64 = await toBase64(e.target.files[0]);
    const param = {
      pendaftaran_id: idPendaftaran,
      penilaian_id: data.ref_sub_penilaian_id
        ? data.ref_sub_penilaian_id
        : data.pirt_ref_penilaian_id
        ? data.pirt_ref_penilaian_id
        : 0,
      jenis_pendaftaran: "pirt",
      jenis_perbaikan: "penilaian",
      upload: fileBase64,
    };
    try {
      const result = await apiService.post(
        "department/perbaikan/upload",
        param
      );
      if (result) {
        setIsLoading(false);
        setIsCompleted(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <label>
        <span className='text-success pr-2'>
          {isCompleted && (
            <span>
              sukses <i className='fas fa-check-circle fa-1x' />
            </span>
          )}
        </span>
      </label>
      {!isCompleted && (
        <input type='file' onChange={(e) => handleChange(e, data)} />
      )}
      <br />
      {isLoading ? (
        <InlineLoading isLoading={isLoading} />
      ) : error ? (
        <span className='text-danger'>{error}</span>
      ) : (
        ""
      )}
    </>
  );
};

const Perbaikan = ({ data, idPendaftaran }) => {
  const openFile = (url) => {
    const win = window.open(url, "_blank");
    if (!win) {
      win.focus();
    }
  };

  return (
    <>
      <h2 className='mb-2'> Hasil Penilaian</h2>
      <Table
        pagination={false}
        headers={[
          "No",
          "Nama",
          "Penilaian",
          "Nilai",
          "File Terdahulu",
          "Upload File",
        ]}
        data={data}
        columnMapper={(value, i) => {
          return [
            <div>{value.name}</div>,
            value.sub.map((sub) => <div>{sub.name}</div>),
            value.sub.map((sub) => (
              <div>
                {sub.value === true
                  ? "Tidak Lolos"
                  : sub.value === false
                  ? "Lolos"
                  : "Belum Dinilai"}
              </div>
            )),
            value.sub.map((sub) =>
              sub.trx_perbaikan ? (
                <div
                  onClick={() => openFile(sub.trx_perbaikan.upload)}
                  className='text-primary'
                  style={{ cursor: "pointer" }}>
                  Lihat file perbaikan terdahulu
                </div>
              ) : (
                <div>Tidak ada file</div>
              )
            ),
            value.sub.map((sub) =>
              sub.value === false ? (
                <div>
                  <span className='badge badge-primary'>Lulus Penilaian</span>
                  <br />
                </div>
              ) : (
                <>
                  <UploadFile data={sub} idPendaftaran={idPendaftaran} />
                </>
              )
            ),
          ];
        }}
      />
    </>
  );
};

export default Perbaikan;
